import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { defaultLoginValues, Login } from 'src/app/components/login/login';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { LoginService } from 'src/app/services/login.service';
import { NgForm } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { TranslationService } from 'src/app/services/translation.service';
import { LanguageService } from 'src/app/services/language.service';
import { AccessControl, AccessControlDefaultValues } from 'src/app/components/users/access-control';
import { faEnvelope, faEye, faEyeSlash, faLock, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { RoleOnboardingService } from 'src/app/services/role-onboarding.service';
import { AuthModel } from 'src/app/components/authorize/auth-model';

@Component({
    selector: 'app-bb-login',
    templateUrl: './bb-login.component.html',
    styleUrls: ['./bb-login.component.scss'],
    standalone: false
})

export class BbLoginComponent {
  loginObj: Login = defaultLoginValues();
  token: string = "";
  errorDivVisible: boolean = false;
  errorDivHeading: string = "";
  errorDivMessage: string = "";
  errorDivButtonText: string = "";
  applicationRoles: any[] = [];
  selectedRole: number = 1;
  userLoginPage: string = "Coached Participant";
  loginLabel: string = "Log In";
  loginPasswordExpired: string = "Your Password has expired";
  loginInvalidPassword: string = "Invalid Username and/or Password";
  loginForgotPassword: string = "Forgot password?";
  loginButtonText: string = "Log In";
  loginTryAgain: string = "Try Again";
  loginFieldRequired: string = "Field is required";
  loginOtpInvalid: string = "Invalid or expired verification code";
  revealPassword: boolean = false;
  faEye: IconDefinition = faEye;
  faEyeSlash: IconDefinition = faEyeSlash;
  faLock: IconDefinition = faLock;
  faEnvelope: IconDefinition = faEnvelope;
  translation: any;
  isLoading = false;
  accessControl:AccessControl = AccessControlDefaultValues()
  requiresTwoFactor = false;
  twoFactorToken = '';
  otpCode = '';
  isResendingOtp = false;

  @ViewChild('submitButton') submitButton!: ElementRef;
  constructor(public _loginService: LoginService,
    private _authService: AuthService,
    public router: Router,
    public _userserivce: UserService,
    private route: ActivatedRoute,
    private translationService: TranslationService,
    private langservice: LanguageService,
    private roleOnboardingService: RoleOnboardingService) { }

  ngOnInit() {
    this.translationService.getTranslation().subscribe((translations: any) => {
      this.translation = translations;
      this.loginPasswordExpired = translations['loginPasswordExpired'];
      this.loginInvalidPassword = translations['loginInvalidPassword'];
      this.loginOtpInvalid = translations['loginOtpInvalid'] || this.loginOtpInvalid;
    });
    this.loginWithToken();
  }

  loginCMHA(logincmhaform: NgForm): void {
    if (!logincmhaform.invalid) {
      this.loginObj.userDbId = 0;
      this.loginObj.email = "TestEmail";
      this.loginObj.roles = this.selectedRole;
      this.isLoading = true;

      setTimeout(() => {
        this._loginService.loginBBUser(this.loginObj).subscribe({
          next: (res) => {
            if (res.requiresTwoFactor && res.twoFactorToken) {
              this.isLoading = false;
              this.requiresTwoFactor = true;
              this.twoFactorToken = res.twoFactorToken;
              this.otpCode = '';
              this.setErrorDiv('', '', '', false);
              return;
            }
            this.handleSuccessfulAuthResponse(res);
          },
          error: () => {
            this.isLoading = false;
            this.setErrorDiv(this.loginInvalidPassword, '', 'Try Again', true);
          }
        });
      }, 2000);
    } else {
      Object.values(logincmhaform.controls).forEach(control => control.markAllAsTouched());
    }

  }

  verifyOtp(otpForm: NgForm): void {
    if (otpForm.invalid || !this.twoFactorToken) {
      Object.values(otpForm.controls).forEach(control => control.markAllAsTouched());
      return;
    }

    this.isLoading = true;
    this._loginService.verifyTwoFactor(this.twoFactorToken, this.otpCode, this.loginObj.rememberMe).subscribe({
      next: (res) => {
        this.handleSuccessfulAuthResponse(res, true);
      },
      error: () => {
        this.isLoading = false;
        this.setErrorDiv(this.loginOtpInvalid, '', 'Try Again', true);
      }
    });
  }

  resendOtp(): void {
    if (!this.twoFactorToken || this.isResendingOtp) {
      return;
    }

    this.isResendingOtp = true;
    this._loginService.resendTwoFactor(this.twoFactorToken).subscribe({
      next: (res) => {
        this.isResendingOtp = false;
        if (res.requiresTwoFactor && res.twoFactorToken) {
          this.twoFactorToken = res.twoFactorToken;
          this.otpCode = '';
          this.setErrorDiv('', '', '', false);
        } else {
          this.setErrorDiv(this.loginOtpInvalid, '', 'Try Again', true);
        }
      },
      error: () => {
        this.isResendingOtp = false;
        this.setErrorDiv(this.loginOtpInvalid, '', 'Try Again', true);
      }
    });
  }

  backToPasswordStep(): void {
    this.requiresTwoFactor = false;
    this.twoFactorToken = '';
    this.otpCode = '';
    this.setErrorDiv('', '', '', false);
  }

  private handleSuccessfulAuthResponse(res: AuthModel, fromOtp = false): void {
    if (res.isLoginSuccessful) {
      if (res.passwordChangeRequiredDays > 0) {
        this._authService.setUserLoginData(res);
        this.redirectAfterLogin(res.isParticipant);
      } else {
        this.isLoading = false;
        this.setErrorDiv(this.loginPasswordExpired, '', 'Reset Password', true);
      }
    } else {
      this.isLoading = false;
      this.setErrorDiv(fromOtp ? this.loginOtpInvalid : this.loginInvalidPassword, '', 'Try Again', true);
    }
  }

  loginWithToken(): void {
    const token = this._authService.getUserLoginData().token
    if (token != null) {
      this.loginObj.authToken = token
      this._loginService.loginUsingAuthToken(this.loginObj).subscribe({
        next: (res) => {
          this._authService.setUserLoginData(res);
          if (res.isLoginSuccessful) {
            this.redirectAfterLogin(res.isParticipant);
          }
        }
      });
    }
  }

  redirectAfterLogin(isParticipant: boolean): void {
    this.roleOnboardingService.getPending().subscribe({
      next: (pending) => {
        if (pending && pending.some(c => c.isMandatory)) {
          this.router.navigateByUrl('/onboarding-training');
          return;
        }
        if (isParticipant) {
          this.navigateToParticipantDashboard();
        } else {
          this.router.navigateByUrl('/dashboard-bb');
        }
      },
      error: () => {
        if (isParticipant) {
          this.navigateToParticipantDashboard();
        } else {
          this.router.navigateByUrl('/dashboard-bb');
        }
      }
    });
  }

  navigateToParticipantDashboard()
  {
    this._userserivce.getAccessControlForUser().subscribe({
      next: (data) => {
        this.accessControl = data;
        this._authService.setAccessControl(this.accessControl);
        
      },
      error:() =>
      {
        console.log("Error Occured")
      },
      complete:() =>{
        this.router.navigateByUrl('/dashboard-participant');
      }

  })
  
  }

  hideErrorDiv() {
    switch (this.errorDivButtonText.toUpperCase().replace(' ', '')) {
      case "TRYAGAIN":
        this.setErrorDiv('', '', '', false);
        break;
      case "RESETPASSWORD":
        this.router.navigate(['/forgot-password/CMHA']);
        break;
      default:
        break;
    }
  }

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.submitButton?.nativeElement?.click();
      event.preventDefault();
    }
  }

  setErrorDiv(heading: string, message: string, buttonText: string, visibility: boolean) {
    this.errorDivHeading = heading;
    this.errorDivMessage = message;
    this.errorDivButtonText = buttonText;
    this.errorDivVisible = visibility
  }
}
